<template>
  <v-dialog v-bind="$attrs" v-model="showDialog">
    <v-card>
      <v-card-title class="heading text_color--text">
        <span
          class="text-lg-subtitle-1 text-xl-h6 text-uppercase font-weight-black text_color--text"
          v-if="title"
          >{{ title }}</span
        >
        <v-spacer></v-spacer>
        <v-btn icon depressed @click="closeDialog()" v-if="showCloseButton">
          <v-icon color="text_color--text">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <slot name="dialogContent" />
      </v-card-text>
      <v-card-actions class="d-flex justify-end align-center">
        <slot name="dialogActions" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Title",
    },
    showCloseButton: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    showDialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    closeDialog() {
      this.$emit("onDialogClose");
      this.showDialog = false;
    },
  },
};
</script>

<style></style>
